import React from 'react';

import CustomTable from '../../../components/CustomTable';

import './styles.css'

export default function ResultList(props) {
    return (
        <CustomTable
            className={'table-reporte-registro-venta'}
            pagination={props.pagination}
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingSIRE={props.loadingSIRE}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onExportSIRE={props.onExportSIRE}
            onExportPdfRegistrado={props.onExportPdfRegistrado}
            onPrint={props.onPrint}
            onChange={props.onChange}
            rowKey={record => record.id}
            columns={[
           
                {
                    title: 'Periodo',
                    dataIndex: 'periodo',
                    key: 'periodo',
                    sorter: true
                },
                {
                    title: 'Cuo',
                    dataIndex: 'Cuo',
                    key: 'cuo',
                    sorter: true
                },

                {
                    title: 'Correlativo',
                    dataIndex: 'correlativo',
                    key: 'correlativo',
                    sorter: true
                },
                {
                    title: 'Fecha de emisión del comprobante de pago o documento',
                    dataIndex: 'fechaEmisionStr',
                    key: 'fechaEmisionStr',
                    sorter: true
                },
                {
                    title: 'Fecha de vencimiento y/o pago',
                    dataIndex: 'fechaVencimientoStr',
                    key: 'fechaVencimientoStr',
                    sorter: true
                },
                {
                    title: 'Comprobante de pago o documento',
                    className: 'parent-group',
                    children: [
                        {
                            title: 'Tipo CP / Doc.',
                            dataIndex: 'tipo',
                            key: 'tipo',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Nº serie del CDP',
                            dataIndex: 'serie',
                            key: 'serie',
                            className: 'child-group',
                            sorter: true
                        },
               
                        {
                            title: 'Nº CP o Doc. Nro Inicial (Rango)',
                            dataIndex: 'numero',
                            key: 'numero',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Nro Final (Rango)',
                            dataIndex: 'rangoFinal',
                            key: 'rangoFinal',
                            className: 'child-group',
                            sorter: true
                        }
                    ]
                },
                {
                    title: 'Información del Cliente',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Tipo',
                            dataIndex: 'documento',
                            key: 'documento',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Número',
                            dataIndex: 'ruc',
                            key: 'ruc',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Apellidos y nombres denominación o razón social',
                            dataIndex: 'razonSocial',
                            key: 'razonSocial',
                            className: 'child-group child-group-2',
                            sorter: true,
                            render: (value) => (
                                <div style={{ minWidth: "300px" }}>{value}</div>
                            )
                        }
                    ]
                },

                {
                    title: 'Exportación',
                    dataIndex: 'valorFacturadoExportacionStr',
                    key: 'valorFacturadoExportacionStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Base imponible gravada',
                    dataIndex: 'baseImponibleStr',
                    key: 'baseImponibleStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Descuento base imponible gravada',
                    dataIndex: 'descuentoBaseImponibleStr',
                    key: 'descuentoBaseImponibleStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'IGV 18% y 10%',
                    dataIndex: 'igvStr',
                    key: 'igvStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Descuento IGV 18% y 10%',
                    dataIndex: 'descuentoIGVStr',
                    key: 'descuentoIGVStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Importe total de la operación exonerada o inafecta',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Exonerada',
                            dataIndex: 'exoneradaStr',
                            key: 'exoneradaStr',
                            align: 'right',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Inafecta',
                            dataIndex: 'inafectaStr',
                            key: 'inafectaStr',
                            align: 'right',
                            className: 'child-group child-group-2',
                            sorter: true
                        }
                    ]
                },
                {
                    title: 'ISC',
                    dataIndex: 'iscStr',
                    key: 'iscStr',
                    align: 'right',
                    sorter: true
                },
       
                {
                    title: 'Operación Grabada con el IVAP',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Base Imponible',
                            dataIndex: 'baseImponibleIVAPStr',
                            key: 'baseImponibleIVAPStr',
                            align: 'right',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'IVAP',
                            dataIndex: 'impuestoIVAPStr',
                            key: 'impuestoIVAPStr',
                            align: 'right',
                            className: 'child-group child-group-2',
                            sorter: true
                        }
                    ]
                },
        
                {
                    title: 'ICBPER',
                    dataIndex: 'icbperStr',
                    key: 'icbperStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Otros conceptos / Tributos',
                    dataIndex: 'otrosTributosStr',
                    key: 'otrosTributosStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Importe total del comprobante de pago',
                    dataIndex: 'totalStr',
                    key: 'totalStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Moneda',
                    dataIndex: 'moneda',
                    key: 'moneda',
                    sorter: true
                },

                {
                    title: 'Tipo de cambio',
                    dataIndex: 'tipoCambioStr',
                    key: 'tipoCambioStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Referencia del comprobante de pago o documento original que se modifica',
                    className: 'parent-group',
                    children: [
                        {
                            title: 'Fecha',
                            dataIndex: 'fechaStr',
                            key: 'fechaStr',
                            align: 'center',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Tipo (Tabla 10)',
                            dataIndex: 'tipoReferencia',
                            key: 'tipoReferencia',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Serie',
                            dataIndex: 'serieReferencia',
                            key: 'serieReferencia',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Nº del comprobante de pago o documento',
                            dataIndex: 'comprobantePagoReferencia',
                            key: 'comprobantePagoReferencia',
                            className: 'child-group',
                            sorter: true
                        }
                    ]
                },
                {
                    title: 'Identificación del proyecto',
                    dataIndex: 'identificacionProyecto',
                    key: 'identificacionProyecto',
                    sorter: true
                },
                {
                    title: 'Error tipo 1',
                    dataIndex: 'errorTipo1',
                    key: 'errorTipo1',
                    sorter: true
                },
                {
                    title: 'Indicador de CP cancelado',
                    dataIndex: 'indicadorCP',
                    key: 'indicadorCP',
                    sorter: true
                },
                {
                    title: 'Estado',
                    dataIndex: 'estado',
                    key: 'estado',
                    sorter: true
                },

                {
                    title: 'Campos de libre utilización',
                    dataIndex: 'campoLibre',
                    key: 'campoLibre',
                    sorter: true
                },
            ]}
        />
    );
}